import { request } from "../../../Services/Api"

export const getRequestsReceiptsFilterOptions = (params) =>
  request.api.get(`/user/requests/receipts/filter_options/`, params)

export const getReceiptsRequests = (params) => request.api.get(`/user/requests/receipts/`, params)

export const getReceiptRequestDetails = (id, params) =>
  request.api.get(`/user/requests/receipts/${id}/`, params)

export const getReceiptProfileUpdateDiff = (id, params) =>
  request.api.get(`/user/requests/receipts/${id}/profile_update/`, params)

export const updateReceiptRequest = ({ id, ...params }) =>
  request.api.patch(`/user/requests/receipts/${id}/`, params)

// Descriptor rows keep their status on a dedicated endpoint: the row PATCH above only carries the
// comment and the archive flag and deliberately leaves the status alone.
export const updateReceiptStatus = ({ id, status }) =>
  request.api.patch(`/user/requests/receipts/${id}/status/`, { status })

export const updateReceiptProfileStatus = ({ id, status }) =>
  request.api.patch(`/user/requests/receipts/${id}/profile_update/status/`, { status })

export const deleteReceiptRequest = (id) => request.api.delete(`/user/requests/receipts/${id}/`)

// No `file_name`: this export is emailed, and the backend names the file itself
// ("Receipt Request <date>.csv").
export const getRequestsReceiptsExport = (params) =>
  request.api.get(`/user/requests/receipts/export_receipt_request_data/`, params)

// The network enrollment form for one descriptor row (CHA1-2286): an Order Insight row answers
// with the Verifi Merchant Enrollment Form, a Consumer Clarity row with the Ethoca Clarity
// questionnaire. The record itself decides which — there is no program parameter to pass.
//
// Unlike the table export above, this one is synchronous: the .xlsx arrives in this response, so it
// needs `responseType: "blob"` and there is no report, email or link to wait for. The filename
// comes from the Content-Disposition header, which the backend exposes to the browser.
export const downloadReceiptEnrollmentForm = (id) =>
  request.api.get(`/user/requests/receipts/${id}/enrollment-form/`, null, {
    responseType: "blob"
  })
